export enum EventDocumentUserRoleEnum {
    Organiser = 1,
    Staff = 2,
}
